export default __webpack_public_path__ + "static/media/hero-dark.aad83232.svg";